import { Location } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { AuthenticationService } from 'app/core/authentication';
import { TOKEN_STORAGE_KEYS } from 'app/core/authentication/constants/token-storage-keys';
import { MergeInfoModel } from 'app/shared/models/merge-info.model';
import { MergeAccountDataService } from 'app/shared/services/merge-account-data-service';
import { TEACHERS_ROUTE } from 'app/teachers/teachers-routing.constant';

@Component({
  selector: 'kh-merge-account-confirmation',
  styleUrls: ['./merge-account-confirmation.component.less'],
  templateUrl: './merge-account-confirmation.component.html',
  standalone: false
})
export class MergeAccountConfirmationComponent implements OnInit {
  private formBuilder = inject(FormBuilder);
  private readonly activatedRoute = inject(ActivatedRoute);
  private readonly location = inject(Location);
  private readonly mergeAccountDataService = inject(MergeAccountDataService);
  private readonly authenticationService = inject(AuthenticationService);

  public mergeInfo$: Observable<MergeInfoModel> | undefined = undefined;
  public confirmMergeForm!: FormGroup;
  public destination = '';
  public confirmMergeFormFields = {
    agree: 'agree'
  };

  public ngOnInit(): void {
    const queryParams = this.activatedRoute.snapshot.queryParamMap;
    this.destination = queryParams.get('destination') as string;
    this.mergeInfo$ = this.mergeAccountDataService.getMergeInfo(this.destination);
    this.confirmMergeForm = this.getConfirmMergeForm();
  }

  public backButton(): void {
    this.location.back();
  }

  public getConfirmMergeForm(): FormGroup {
    return this.formBuilder.group({
      [this.confirmMergeFormFields.agree]: this.formBuilder.control(false, Validators.requiredTrue)
    });
  }

  public getCheckboxControl(): FormControl {
    return this.confirmMergeForm.get(this.confirmMergeFormFields.agree) as FormControl;
  }

  public merge(): void {
    this.mergeAccountDataService.mergeAccount(this.destination)
      .pipe(
        tap(() => {
          const postLogoutRedirect = {
            params: {},
            url: TEACHERS_ROUTE.MERGE_COMPLETE.route()
          };
          localStorage.setItem(TOKEN_STORAGE_KEYS.POST_LOGOUT_REDIRECT, JSON.stringify(postLogoutRedirect));
          this.authenticationService.logOut();
        }))
      .subscribe();
  }
}
